export class AuthResponse {
  auth_token: string;
  user_id: string;
  user_name: string;
  expires_in: number;
  roles: string[];
}
